import axios from 'axios'

export default {
    namespaced: true,
    state: {
        transactions: [],
        headers: [],
        loading: false,
        url_search: '',
        url_sort: '',
        pagination: {
            page_count: 1,
            page: 1,
            per_page: 30
        },
        total_transactions: {
            title: '',
            count: 0
        },
        total_routes_count: {
            title: '',
            count: 0,
            is_loading: true
        },
        total_routes: [],
        chartOptions: {
            title: {
                display: true,
                text: ''
            },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true
                    },
                    gridLines: {
                        display: true
                    }
                }],
                xAxes: [{
                    gridLines: {
                        display: false
                    }
                }]
            },
            legend: {
                display: false
            },
            responsive: true,
            maintainAspectRatio: false
        },
        chartData: null,
        chart_is_loading:false
    },
    getters: {
        get_chart_is_loading(state){
            return state.chart_is_loading
        },
        get_chart_data(state) {
            return {
                chartOptions: state.chartOptions,
                chartData: state.chartData
            }
        },
        get_loading(state) {
            return state.loading;
        },
        get_headers(state) {
            return state.headers
        },
        get_transactions(state) {
            return state.transactions
        },
        get_pagination(state) {
            return state.pagination
        },
        get_url_search(state) {
            return state.url_search
        },
        get_url_sort(state) {
            return state.url_sort
        },
        get_total_transactions(state) {
            return state.total_transactions
        },
        get_total_routes_count(state) {
            return state.total_routes_count
        },
        get_loading_total_routes_count(state) {
            return state.total_routes_count.is_loading
        },
        get_total_routes(state) {
            return state.total_routes
        }
    },
    mutations: {
        set_chart_data(state, value) {
            state.chartData = value.chartdata
            state.chartOptions = value.options

        },
        set_total_routes(state, value) {
            state.total_routes = value
        },
        set_total_routes_count(state, value) {
            state.total_routes_count = value
        },
        set_total_transactions(state, obj) {
            state.total_transactions.title = obj.title
            state.total_transactions.count = obj.count
        },
        set_loading(state, value) {
            state.loading = value
        },
        set_loading_total_routes_count(state, value) {
            state.total_routes_count.is_loading = value
        },
        set_loading_chart_data(state, value) {
            state.chart_is_loading = value
        },
        set_pagination(state, obj) {
            state.pagination.page = obj.current_page
            state.pagination.page_count = obj.last_page
            state.pagination.per_page = obj.per_page
        },
        set_headers(state, headers) {
            state.headers = headers
        },
        set_transactions(state, transactions) {
            state.transactions = transactions
        },
        set_url_sort(state, value) {
            state.url_sort = value
        },
        set_url_search(state, value) {
            state.url_search = value
        }

    },
    actions: {
        async fetch_chart_data({commit},payload) {
           await commit('set_loading_chart_data', true)
            console.log(payload)
            try {
                const response = await axios.get('/api/transport/sber/chart-data/'+payload.type)
                if (response.status === 200) {
                    commit('set_chart_data', response.data)
                }
            } finally {
                await  commit('set_loading_chart_data', false)
            }
        },
        async fetch_total_routes({commit}) {
            commit('set_loading', true)
            try {
                const response = await axios.get('/api/transport/sber/total-routes')
                if (response.status === 200) {
                    commit('set_total_routes', response.data)
                }
            } finally {
                commit('set_loading', false)
            }
        },
        async fetch_total_routes_count({commit, state}) {
            commit('set_loading_total_routes_count', true)
            try {
                const response = await axios.get('/api/transport/sber/total-routes-count')
                if (response.status === 200) {
                    commit('set_total_routes_count', response.data)
                }
            } finally {
                commit('set_loading_total_routes_count', false)
            }
        },
        async fetch_total_transactions({commit, state}) {
            commit('set_loading', true)
            try {
                const response = await axios.get('/api/transport/sber/total-transactions')
                if (response.status === 200) {
                    commit('set_total_transactions', response.data)
                }
            } finally {
                commit('set_loading', false)
            }
        },
        async fetch_sber({commit, state}) {
            commit('set_loading', true)
            try {
                const response = await axios.get('/api/transport/sber?page='
                    + state.pagination.page
                    + state.url_search
                    + state.url_sort)
                if (response.status === 200) {
                    commit('set_pagination', {
                        current_page: response.data.paginate.current_page,
                        last_page: response.data.paginate.last_page,
                        per_page: response.data.paginate.per_page
                    })
                    commit('set_transactions', response.data.transactions)
                    commit('set_headers', response.data.headers)
                }
            } catch (e) {

            } finally {
                commit('set_loading', false)
            }
        }
    }
}